function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Stringify a CST document, token, or collection item
 *
 * Fair warning: This applies no validation whatsoever, and
 * simply concatenates the sources in their logical order.
 */
var stringify = function stringify(cst) {
  return 'type' in cst ? stringifyToken(cst) : stringifyItem(cst);
};

function stringifyToken(token) {
  switch (token.type) {
    case 'block-scalar':
      {
        var res = '';

        var _iterator = _createForOfIteratorHelper(token.props),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tok = _step.value;
            res += stringifyToken(tok);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return res + token.source;
      }

    case 'block-map':
    case 'block-seq':
      {
        var _res = '';

        var _iterator2 = _createForOfIteratorHelper(token.items),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _res += stringifyItem(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return _res;
      }

    case 'flow-collection':
      {
        var _res2 = token.start.source;

        var _iterator3 = _createForOfIteratorHelper(token.items),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item = _step3.value;
            _res2 += stringifyItem(_item);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(token.end),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var st = _step4.value;
            _res2 += st.source;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return _res2;
      }

    case 'document':
      {
        var _res3 = stringifyItem(token);

        if (token.end) {
          var _iterator5 = _createForOfIteratorHelper(token.end),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _st = _step5.value;
              _res3 += _st.source;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }

        return _res3;
      }

    default:
      {
        var _res4 = token.source;

        if ('end' in token && token.end) {
          var _iterator6 = _createForOfIteratorHelper(token.end),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _st2 = _step6.value;
              _res4 += _st2.source;
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }

        return _res4;
      }
  }
}

function stringifyItem(_ref) {
  var start = _ref.start,
      key = _ref.key,
      sep = _ref.sep,
      value = _ref.value;
  var res = '';

  var _iterator7 = _createForOfIteratorHelper(start),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _st3 = _step7.value;
      res += _st3.source;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  if (key) res += stringifyToken(key);

  if (sep) {
    var _iterator8 = _createForOfIteratorHelper(sep),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var st = _step8.value;
        res += st.source;
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  if (value) res += stringifyToken(value);
  return res;
}

export { stringify };